/**
 * Latvian character normalization utility
 * Converts Latvian diacritics to their base characters for search and comparison
 */

/**
 * Latvian character mapping for normalization
 * Maps Latvian diacritics to their base characters
 */
const LATVIAN_CHAR_MAP: Record<string, string> = {
  // Lowercase
  'ā': 'a',
  'ē': 'e', 
  'ī': 'i',
  'ū': 'u',
  'š': 's',
  'ģ': 'g',
  'ķ': 'k',
  'ļ': 'l',
  'ņ': 'n',
  'č': 'c',
  'ž': 'z',
  
  // Uppercase
  'Ā': 'A',
  'Ē': 'E',
  'Ī': 'I', 
  'Ū': 'U',
  'Š': 'S',
  'Ģ': 'G',
  'Ķ': 'K',
  'Ļ': 'L',
  'Ņ': 'N',
  'Č': 'C',
  'Ž': 'Z'
};

/**
 * Normalizes a string by converting Latvian diacritics to base characters
 * and converting to lowercase
 * 
 * @param text - The text to normalize
 * @returns The normalized text in lowercase
 */
export function normalizeLatvianText(text: string): string {
  if (!text) return '';
  
  let normalized = text;
  
  // Replace Latvian diacritics with base characters
  for (const [diacritic, base] of Object.entries(LATVIAN_CHAR_MAP)) {
    normalized = normalized.replace(new RegExp(diacritic, 'g'), base);
  }
  
  // Convert to lowercase
  return normalized.toLowerCase();
}

/**
 * Normalizes text for search purposes
 * This is the main function to use for search normalization
 * 
 * @param text - The text to normalize for search
 * @returns The normalized text ready for search comparison
 */
export function normalizeForSearch(text: string): string {
  return normalizeLatvianText(text);
}
